import { useState } from "react";

import {
  makeGetApiCall,
  makePostApiCall,
  makePutApiCall,
} from "../../../shared/makeApiCall";
import CustomerTypeDetailsForm from "../../../components/forms/setup/customerTypes/CustomerTypeDetailsForm";
import { BannerNotificationType } from "../../../components/SimpleNotification";
import DeleteConfirmationForm from "../../../components/forms/DeleteConfirmationForm";
import { updateObjectInArray } from "../../../shared/utility";

export function CustomerTypesViewModel(logout) {
  const [loading, setLoading] = useState(false);
  const [customerTypes, setCustomerTypes] = useState({
    data: [],
  });
  const [showSimpleNotification, setShowSimpleNotification] = useState({
    show: false,
    message: null,
    title: null,
    type: BannerNotificationType.Success,
  });
  const [slideOver, setSlideOver] = useState({
    childComponent: null,
    open: false,
  });
  const [emptyModal, setEmptyModelOpen] = useState({
    open: false,
    childComponent: null,
  });

  const getCustomerTypes = async function (search, page) {
    setLoading(true);

    let callResult = await makePostApiCall(
      `customerTypes?page=${page}&search=${search}`
    );
    setLoading(false);
    if (callResult.success) {
      setCustomerTypes(callResult.data);
    } else {
      if (callResult.errorStatus === 401) {
        logout();
      }
    }
  };

  const createCustomerType = async function (values) {
    const payload = { ...values };
    let callResult = await makePostApiCall("customerTypes/create", payload);

    if (callResult.success) {
      setShowSimpleNotification({
        show: true,
        title: "Customer type added",
        type: BannerNotificationType.Success,
      });
      setSlideOver({
        childComponent: null,
        open: false,
      });
      setTimeout(function () {
        getCustomerTypes("", 1);
      }, 1000);
    } else {
      if (callResult.errorStatus === 401) {
        logout();
      }
    }
  };

  const updateCustomerType = async function (values, index) {
    let callResult = await makePutApiCall(`customerTypes/${values.id}`, values);

    if (callResult.success) {
      setShowSimpleNotification({
        show: true,
        title: "Customer type updated",
        type: BannerNotificationType.Success,
      });
      setSlideOver({
        childComponent: null,
        open: false,
      });

      const currentItems = [...customerTypes.data];
      var payload = {
        index: index,
        item: callResult.data.item,
      };
      const newItems = updateObjectInArray(currentItems, payload);
      setCustomerTypes({ ...customerTypes, data: newItems });
    } else {
      if (callResult.errorStatus === 401) {
        logout();
      }
    }
  };

  const openAddCustomerTypeSlideOver = (isEdit, customerType, index) => {
    setSlideOver({
      childComponent: (
        <CustomerTypeDetailsForm
          customerType={customerType}
          isEdit={isEdit}
          setOpen={setSlideOver}
          actionCall={(payload) =>
            isEdit
              ? updateCustomerType(payload, index)
              : createCustomerType(payload)
          }
          title={
            isEdit ? `Update ${customerType.name}` : "Add new customer type"
          }
        />
      ),
      open: true,
    });
  };

  const deleteCustomerType = async function (id, index) {
    setLoading(true);

    let callResult = await makePostApiCall(`deleteCustomerType/${id}`);
    setLoading(false);
    if (callResult.success) {
      setEmptyModelOpen({
        open: false,
        childComponent: null,
      });

      const newItems = customerTypes.data.filter((item) => item.id !== id);
      setCustomerTypes({ ...customerTypes, data: newItems });

      setShowSimpleNotification({
        show: true,
        title: callResult.data.message,
        type: BannerNotificationType.Success,
      });
    } else {
      if (callResult.errorStatus === 401) {
        logout();
      }
    }
  };

  const askDeleteCustomerType = function (customerType, index) {
    setEmptyModelOpen({
      childComponent: (
        <DeleteConfirmationForm
          buttonMessage="Delete"
          confirmAction={() => deleteCustomerType(customerType.id, index)}
          message={`Are you sure you want to delete  ${customerType.name}?`}
          setOpen={setEmptyModelOpen}
          hideReason={true}
        />
      ),
      open: true,
    });
  };

  return {
    openAddCustomerTypeSlideOver,
    getCustomerTypes,
    loading,
    customerTypes,
    setSlideOver,
    slideOver,
    setShowSimpleNotification,
    showSimpleNotification,
    setEmptyModelOpen,
    emptyModal,
    askDeleteCustomerType,
  };
}
